import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

import { computed, ref, onMounted, nextTick, watch, useAttrs, useTemplateRef } from "vue";
import { VCard } from "vuetify/components";
import { UseDraggableDialogOptions, useDraggableDialog } from "../composables/useDraggableDialog";

interface CDSDialogProps {
  title: string;
  modelValue?: boolean;
  color?: string;
  titleColor?: string;
  shortTitle?: string;
  draggable?: boolean;
  button?: boolean;
  scrim?: boolean;
  persistent?: boolean;
  modal?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CDSDialog',
  props: {
    title: {},
    modelValue: { type: Boolean, default: false },
    color: { default: "red" },
    titleColor: { default: "primary" },
    shortTitle: { default: "" },
    draggable: { type: Boolean, default: false },
    button: { type: Boolean, default: false },
    scrim: { type: Boolean, default: true },
    persistent: { type: Boolean, default: false },
    modal: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const card = useTemplateRef<InstanceType<typeof VCard>>("card");
const showDialog = ref(props.modelValue);
const displayedShortTitle = computed(() => props.shortTitle || props.title);
const cardRoot = ref<HTMLElement | null>(null);

const attrs = useAttrs();

if (props.draggable) {
  const options: UseDraggableDialogOptions = {
    root: cardRoot,
    dialogSelector: ".cds-dialog-card",
  };
  if (attrs["drag-predicate"]) {
    options.dragPredicate = attrs["drag-predicate"] as (element: HTMLElement) => boolean;
  }
  useDraggableDialog(options);
}

function updateRoot() {
  nextTick(() => {
    if (card.value) {
      cardRoot.value = card.value.$el;
    }
  });
}

function close(event: PointerEvent) {
  showDialog.value = false;
  event.stopPropagation();
}

onMounted(() => {
  if (props.draggable && props.modelValue) {
    updateRoot();
  }
});

watch(showDialog, value => {
  emit("update:modelValue", value);
});

watch(() => props.modelValue, value => {
  showDialog.value = value;
  if (value && props.draggable) {
    updateRoot();
  }
});


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    class: _normalizeClass(['cds-dialog', `${displayedShortTitle.value.toLowerCase().replace(/ /g, '-')}-cds-dialog`, !__props.modal ? 'nonmodal' : '']),
    modelValue: showDialog.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showDialog).value = $event)),
    scrim: __props.scrim,
    persistent: __props.persistent,
    "no-click-animation": !__props.modal
  }, {
    activator: _withCtx(($attrs) => [
      _renderSlot(_ctx.$slots, "activator", _normalizeProps(_guardReactiveProps($attrs)), () => [
        (__props.button)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              color: __props.color,
              title: displayedShortTitle.value,
              class: "cds-dialog-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showDialog.value = true)),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (showDialog.value = true), ["enter"])),
              tabindex: "0"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Open " + _toDisplayString(displayedShortTitle.value), 1)
              ]),
              _: 1
            }, 8, ["color", "title"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(VCard), {
        ref_key: "card",
        ref: card,
        class: "cds-dialog-card"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar, {
            density: "compact",
            color: __props.titleColor
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar_title, { text: __props.title }, null, 8, ["text"]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                class: "cds-dialog-close-icon",
                icon: "mdi-close",
                onClick: close,
                "onKeyup:enter": close
              })
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _cache[3] || (_cache[3] = _createTextVNode(" Add content to the default slot ", -1))
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 512)
    ]),
    _: 3
  }, 8, ["class", "modelValue", "scrim", "persistent", "no-click-animation"]))
}
}

})